import React, { useState } from 'react';
import { isMobile } from 'react-device-detect';
import { ChevronLeftIcon } from '@heroicons/react/24/outline';
import { Form, Formik } from 'formik';
import styled from 'styled-components';
import Spinner from 'ui-kit/Spinner';
import { colors } from 'ui-kit/theme/colors';
import * as Yup from 'yup';

const validationSchema = Yup.object().shape({
  setup: Yup.string()
    .required("Scenario setup can't be empty")
    .trim()
});

export const ScenarioSetupTool = (props) => {
  const {
    initialSetup = '',
    onContinue = () => { },
    onBack = () => { },
    onChange = () => { }
  } = props;

  const [loading, setLoading] = useState(false);

  return (
    <Wrapper>
      <Formik
        initialValues={{ setup: initialSetup }}
        validationSchema={validationSchema}
        onSubmit={async (values) => {
          if (loading) return;
          setLoading(true);
          await onContinue(values.setup);
          setLoading(false);
        }}
      >
        {({ values, errors, touched, handleChange }) => (
          <Form>
            <Row>
              <Label>Setup</Label>
              <Description>Background to the start of the chat</Description>
              <TextArea
                placeholder='Scenario setup'
                name="setup"
                value={values.setup}
                onChange={(evt) => {
                  handleChange(evt);
                  onChange(evt.target.value);
                }}
              />
              {errors.setup && touched.setup && (
                <ErrorMessage>{errors.setup}</ErrorMessage>
              )}
            </Row>

            <ButtonPlaceholder>
              {isMobile && (
                <MobileBackButton
                  type="button"
                  onClick={onBack}
                >
                  <ChevronLeftIcon />
                </MobileBackButton>
              )}
              {!isMobile && (
                <TransparentButton
                  type="button"
                  onClick={onBack}
                >
                  Back
                </TransparentButton>
              )}

              <OrangeButton isMobile={isMobile} type="submit">
                {loading ? <Spinner /> : 'Continue'}
              </OrangeButton>
            </ButtonPlaceholder>
          </Form>
        )}
      </Formik>
    </Wrapper>
  );
};

const Wrapper = styled.div`
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: 32px;
    min-height: 400px;
    position: relative;
    padding-bottom: 60px;

    @media (max-width: 768px) {
      padding-bottom: 0;
    }
`;

const Label = styled.span`
  font-family: Nunito Sans;
  font-weight: 700;
  font-size: 16px;
  line-height: 18px;
  margin-bottom: -8px;
`;

const Description = styled.span`
  color: #A9A9A9;
  font-family: Nunito Sans;
  text-align: left;
  font-weight: 400;
  font-size: 14px;
  line-height: 16px;
`;

const Row = styled.div`
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: 16px;
    padding-bottom: 32px;
`;

const TextArea = styled.textarea`
  background-color: rgba(19, 19, 19, 1) !important;
  border: 1px solid transparent;
  border-radius: 8px;
  color: white;
  min-height: 250px;
  max-height: 300px;
  font-size: 16px;
  line-height: 18px;
  outline: none;
  font-family: Nunito Sans;
  padding: 16px;
  :focus {
    border-color: #FF7E55;
    box-shadow: none !important;
  }
  ::placeholder {
    color: rgba(105, 105, 105, 1);
  }

  @media (max-width: 500px) {
    min-height: 300px;
  }
`;

const ButtonPlaceholder = styled.div`
    padding-top: 8px;
    width: 100%;
    display: flex;
    gap: 10px;
    position: absolute;
    bottom: 0;
    
    @media (max-width: 768px) {
      margin-top: auto;
      background: #1A1A1A;
      padding-top: 10px;
      padding-bottom: 16px;
      position: fixed;
      width: 100%;
      z-index: 10;
    }
`;

const OrangeButton = styled.button`
    background-color: rgba(255, 126, 85, 1);
    width: ${props => props.isMobile ? '66%' : '100%'};
    padding: 8px 24px;
    border-radius: 100px;
    font-family: Nunito Sans;
    font-size: 18px;
    font-weight: 700;
    line-height: 24px;
    box-shadow: 0px 12px 40px 0px rgba(255, 126, 85, 0.12);
    display: flex;
    justify-content: center;
`;

const TransparentButton = styled(OrangeButton)`
    background-color: transparent;
    border: 1px solid rgba(255, 126, 85, 1);
    color: rgba(255, 126, 85, 1);
    box-shadow: none;
`;

const MobileBackButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 64px;
  height: 40px;
  background: #1A1A1A;
  border-radius: 100px;
  color: white;
  border: 1px solid #FF7E55;
  cursor: pointer;
  padding: 0;
  
  svg {
    width: 24px;
    height: 24px;
  }
`;

const ErrorMessage = styled(Description)`
  color: ${colors.error};
`;